<template>
    <div>
        <b-modal id="edit" size="lg" title="Düzenle" scrollable no-close-on-esc no-close-on-backdrop>
            <g-calculate-salary-process-edit v-model="data"></g-calculate-salary-process-edit> 
            <template #modal-footer><v-executer :loading="updating" :action="update">Kaydet</v-executer></template>
        </b-modal>

        <b-modal id="upload" title="Excel Yükle" scrollable no-close-on-esc no-close-on-backdrop>
            <g-calculate-salary-process-upload v-model="uploadObject"></g-calculate-salary-process-upload> 
            <template #modal-footer><v-executer :loading="uploading" :action="upload">Yükle</v-executer></template>
        </b-modal>

        <b-card no-body class="mb-1">
            <v-table    ref="table" 
                        :fields="fields"
                        with-items
                        :items="datas"
                        pagination="client"
                        :buttons="buttons"
                        :settings="false">
                <template #additional-actions>
                    <div class="row align-items-center">
                        <div class="col-md-3 mb-1 mb-md-0">             
                            <b-input-group class="input-group-merge">
                                <template #prepend>
                                    <b-input-group-text >
                                        <feather-icon icon="SearchIcon"></feather-icon>
                                    </b-input-group-text>
                                </template>
                                <b-form-input placeholder="Ara..." v-on:keyup.enter="getData" v-model="searchValue"></b-form-input>
                            </b-input-group>
                        </div>
                        <div class="col-auto">
                            <button class="btn btn-success" v-on:click="getData">Sorgula</button>
                        </div>
                        <div class="col-md-auto ml-auto">
                            <b-dropdown text="İşlemler" right variant="primary" >
                                <b-dropdown-item v-on:click="uploadExcel">Excel Yükle</b-dropdown-item>
                                <b-dropdown-item v-if="excelPath" v-on:click="downloadExcel">
                                    <feather-icon icon="FileIcon" class="mr-50"></feather-icon>
                                    Excel İndir
                                </b-dropdown-item>
                            </b-dropdown>
                        </div>
                    </div>
                </template>
            </v-table>
        </b-card>
        <b-card no-body class="p-50">
            <div class="row justify-content-end">
                <div class="col-auto">
                    <button class="btn btn-sm btn-outline-secondary" v-on:click="$emit('back')">Geri</button>
                </div>
                <div class="col-auto">
                    <button class="btn btn-sm btn-secondary" v-on:click="$emit('next')">İleri</button>
                </div>
            </div>
        </b-card>
    </div>
</template>

<script>
import EmployeeOperationsApi from '@/api/employee-operations'
import { BCard, BInputGroup, BInputGroupText, BFormInput, BDropdown, BDropdownItem } from 'bootstrap-vue';
import GCalculateSalaryProcessEdit from './GCalculateSalaryProcessEdit.vue';
import GCalculateSalaryProcessUpload from './GCalculateSalaryProcessUpload.vue';
import Additional from '@/utilities/additional'

export default{
    components:{
        BCard,
        GCalculateSalaryProcessUpload,
        GCalculateSalaryProcessEdit,
        BInputGroup, 
        BInputGroupText, 
        BFormInput, 
        BDropdown, 
        BDropdownItem
    },
    props:{
        donem:{
            type:Object,
            default:()=>({
                year:null,
                month:null
            })
        },
        filter:{
            type:Object,
            default:() => ({})
        },
    },
    data(){
        return {
            searchValue:'',
            excelPath:null,
            datas:[],
            // Kolon düzeni "Maaş Bilgileri 2 Ekranları" excel'inin "Maaş Listesi" sekmesinin nihai sırasına göredir (46 veri + TMS-KOD, grid'de TMS-KOD gösterilmez).
            // SalaryPaymentTableExcel (2. adım Excel İndir çıktısı / gsal-) ile aynı düzendedir.
            // Değişiklik: Şube [SGK] ve Maaş Destek Ücreti [Baz] kaldırıldı; Maaş Destek [Banka2/Yemek(+Fiili)] eklendi;
            //   5 prim kalemi (Prim/Prim[Destek]/Prim[Yakıt]/Hamaliye/Bekleme) ayrı kolon; bazı başlıklar yeniden adlandırıldı.
            // Veri kaynağı henüz bağlanmayanlar (Maaş Destek Fiili -> 0, Vukuat Kesintisi [Banka 1] -> 0).
            fields:[
                {
                    name:'',
                    children:[
                        {name:'Sıra',key:'Order',tdClass:'text-nowrap text-center'},
                        {name:'Adı Soyadı',key:'FullName',tdClass:'text-nowrap',sticky:true},
                        {name:'TC',key:'IdentityNumber',tdClass:'text-nowrap',tooltip:'Personelin T.C. kimlik numarası.'},
                        {name:'IBAN',key:'IBAN',tdClass:'text-nowrap',tooltip:'Personelin varsayılan banka hesabının IBAN’ı.'},
                        {name:'Unvan',key:'GarageOrTitle',tdClass:'text-nowrap',tooltip:'Personelin görev/unvanı.'},
                        {name:'Şube [Fiili]',key:'ORGANIZASYONEL_SUBEStr',tdClass:'text-nowrap',tooltip:'Personelin en güncel organizasyonel (fiili) şubesi.'},
                        {name:'Maaş [Baz]',key:'GSalaryStr',tdClass:'text-nowrap text-right',thClass:'vt-th-text-right',tooltip:'Personelin tanımlı aylık baz (SGK) maaşı.'},
                        {name:'Maaş Destek Ücreti [Banka 2]',key:'MAAS_DESTEK_BANKA2Str',tdClass:'text-nowrap text-right',thClass:'vt-th-text-right',tooltip:'Maaş Bilgileri 2’den girilen HAM Banka 2 destek tutarı (aylık, prorata uygulanmaz). Salt görünüm — toplam hakedişe girmez.'},
                        {name:'Maaş Destek Ücreti [Yemek]',key:'MAAS_DESTEK_YEMEKStr',tdClass:'text-nowrap text-right',thClass:'vt-th-text-right',tooltip:'Maaş Bilgileri 2’den girilen HAM Yemek destek tutarı (aylık, prorata uygulanmaz). Salt görünüm — toplam hakedişe girmez.'},
                        {name:'ÜTGS [Ücrete Tabi Gün Sayısı]',key:'SGKDays',tdClass:'text-nowrap text-right',thClass:'vt-th-text-right',tooltip:'Ücrete tabi (çalışılan) gün sayısı = SGK günü − eksik günler. Maaş ve fiili destek hesabında kullanılan gün.'},
                        {name:'Giriş Tarihi',key:'SGKEntryDateStr',tdClass:'text-nowrap',tooltip:'SGK işe giriş tarihi.'},
                        {name:'Çıkış Tarihi',key:'SGKExitDateStr',tdClass:'text-nowrap',tooltip:'SGK işten çıkış tarihi (varsa).'},
                        {name:'YİGS [Yıllık İzin Gün Sayısı]',key:'YILLIK_IZINStr',tdClass:'text-nowrap text-right',thClass:'vt-th-text-right',tooltip:'Dönem içi yıllık izin gün sayısı.'},
                        {name:'İİGS [İdari İzin Gün Sayısı]',key:'UCRETLI_IZINStr',tdClass:'text-nowrap text-right',thClass:'vt-th-text-right',tooltip:'Dönem içi idari (ücretli) izin gün sayısı.'},
                        {name:'ÜTOGS [Ücrete Tabi Olmayan Gün Sayısı]',key:'DIGER_EKSIK_GUNStr',tdClass:'text-nowrap text-right',thClass:'vt-th-text-right',tooltip:'Ücrete tabi olmayan (diğer eksik) gün sayısı.'},
                        {name:'Maaş [Baz Fiili]',key:'CALISMA_KAZANCIStr',tdClass:'text-nowrap text-right',thClass:'vt-th-text-right',tooltip:'Çalışma kazancı = (Baz Maaş ÷ 30) × çalışılan gün (ÜTGS).'},
                        {name:'Maaş Destek Ücreti [Banka 2 Fiili]',key:'MAAS_DESTEK_BANKA2_FIILIStr',tdClass:'text-nowrap text-right',thClass:'vt-th-text-right',tooltip:'(Maaş Destek [Banka 2] HAM tutar ÷ 30) × çalışılan gün (ÜTGS). Toplam hakedişe DAHİLDİR.'},
                        {name:'Maaş Destek Ücreti [Yemek Fiili]',key:'MAAS_DESTEK_YEMEK_FIILIStr',tdClass:'text-nowrap text-right',thClass:'vt-th-text-right',tooltip:'(Maaş Destek [Yemek] HAM tutar ÷ 30) × çalışılan gün (ÜTGS). Toplam hakedişe DAHİLDİR.'},
                        {name:'YİÜ [Yıllık İzin Ücreti]',key:'YILLIK_IZIN_KAZANCStr',tdClass:'text-nowrap text-right',thClass:'vt-th-text-right',tooltip:'Yıllık izin kazancı (izinli günlere karşılık gelen ücret).'},
                    ]
                },
                {
                    name:'Prim',
                    thClass:'bg-light-secondary',
                    children:[
                        {name:'FMÜ [Fazla Mesai Ücreti]',key:"MESAI_UCRETIStr",tdClass:'text-right text-nowrap border-left',thClass:'vt-th-text-right text-secondary',tooltip:'Fazla mesai ücreti (puantajdan).'},
                        {name:'FMÜ [Bayram] [Fazla Mesai Ücreti Bayram]',key:"BAYRAM_MESAISIStr",tdClass:'text-right text-nowrap',thClass:'vt-th-text-right text-secondary',tooltip:'Bayram/genel tatil fazla mesai ücreti.'},
                        {name:'Yemek Ücreti',key:"YEMEK_UCRETIStr",tdClass:'text-right text-nowrap',thClass:'vt-th-text-right text-secondary',tooltip:'Yemek Ücreti = ((Yemek1 + Yemek2) ÷ 30 × Yemek Gün) ÷ 30 × (N + H). Kaynak: Maaş Bilgileri 2 → Ek Hakediş (Yemek). N = Normal, H = Hafta Tatili gün sayısı. (Ek hakediş kaydı yoksa mevcut değer korunur.)'},
                        {name:'Yol Ücreti',key:"YOL_UCRETIStr",tdClass:'text-right text-nowrap',thClass:'vt-th-text-right text-secondary',tooltip:'Yol Ücreti = ((Yol1 + Yol2) ÷ 30 × Yol Gün) ÷ 30 × (N + H). Kaynak: Maaş Bilgileri 2 → Ek Hakediş (Yol). N = Normal, H = Hafta Tatili gün sayısı. (Ek hakediş kaydı yoksa mevcut değer korunur.)'},
                        {name:'Prim',key:"PRIMStr",tdClass:'text-right text-nowrap',thClass:'vt-th-text-right text-secondary',tooltip:'Prim tutarı.'},
                        {name:'Prim [Destek]',key:"DESTEK_PRIMIStr",tdClass:'text-right text-nowrap',thClass:'vt-th-text-right text-secondary',tooltip:'Destek primi.'},
                        {name:'Prim [Yakıt]',key:"MAZOT_PRIMIStr",tdClass:'text-right text-nowrap',thClass:'vt-th-text-right text-secondary',tooltip:'Yakıt (mazot) primi.'},
                        {name:'Hamaliye Ücreti',key:"HAMMALIYE_BEDELIStr",tdClass:'text-right text-nowrap',thClass:'vt-th-text-right text-secondary',tooltip:'Hamaliye bedeli.'},
                        {name:'Bekleme',key:"YATMAStr",tdClass:'text-right text-nowrap',thClass:'vt-th-text-right text-secondary',tooltip:'Bekleme (yatma) ücreti.'},
                        {name:'Prim [Toplam]',key:"PRIM_TOPLAMStr",tdClass:'text-right text-nowrap',thClass:'vt-th-text-right text-secondary',tooltip:'Prim [Toplam] = Prim + Prim [Destek] + Hamaliye + Bekleme + Prim [Yakıt].'},
                        {name:'Dengeleyici Ücret',key:"SIFIRLAMAStr",tdClass:'text-right text-nowrap',thClass:'vt-th-text-right text-secondary',tooltip:'Dengeleyici (sıfırlama) ücreti.'},
                        {name:'ODÖ [Olağandışı Ödemeler]',key:"DIGERStr",tdClass:'text-right text-nowrap',thClass:'vt-th-text-right text-secondary',tooltip:'Olağandışı ödemeler (Diğer). Girildiğinde Açıklama zorunludur.'},
                        {name:'Açıklama',key:"DIGERACIKLAMA",tdClass:'text-nowrap border-right',thClass:'vt-th-text-right text-secondary',tooltip:'Olağandışı ödemeler (ODÖ) açıklaması.'},
                    ]
                },
                {
                    name:'',
                    children:[
                        {name:'Toplam Hakediş',key:'TOPLAM_HAKEDISStr',tdClass:'text-nowrap  text-right',thClass:'vt-th-text-right',tooltip:'Toplam Hakediş = Toplam Maaş + Yıllık İzin Kazancı + FMÜ + FMÜ [Bayram] + Yemek + Yol + tüm primler + Dengeleyici + ODÖ + Maaş Destek [Banka 2 Fiili] + Maaş Destek [Yemek Fiili].'},
                        {name:'Ödeme [Banka 1]',key:'BANKAYA_YATANStr',tdClass:'text-nowrap text-right',thClass:'vt-th-text-right',tooltip:'Banka 1 üzerinden resmi bordroya yatan tutar.'},
                    ]
                },
                {
                    name:'Banka 1 Kesintiler',
                    thClass:'bg-light-info',
                    children:[
                        {name:'İcra',key:'ICRAStr',tdClass:'text-nowrap text-right',thClass:'vt-th-text-right',tooltip:'İcra kesintisi (Banka 1).'},
                        {name:'BES',key:'BESStr',tdClass:'text-nowrap text-right',thClass:'vt-th-text-right',tooltip:'Bireysel Emeklilik (BES) kesintisi.'},
                        {name:'Avans [Banka 1]',key:'AVANSStr',tdClass:'text-nowrap text-right',thClass:'vt-th-text-right',tooltip:'Banka 1 avans kesintisi.'},
                        {name:'Trafik Cezası [Banka 1]',key:'TRAFIK_CEZAStr',tdClass:'text-nowrap text-right',thClass:'vt-th-text-right',tooltip:'Banka 1 trafik cezası kesintisi (diğer kesintiler hariç, sadece trafik cezaları).'},
                        {name:'Vukuat Kesintisi [Banka 1]',key:'BANKA_1_VUKUATStr',tdClass:'text-nowrap text-right',thClass:'vt-th-text-right',tooltip:'KYKM grubu ve türü "Kesinti" (TIP 3 / SIRA_NO 6) olan kayıtların tutarı. Toplam Banka 1’e dahildir.'},
                        {name:'Belge İle Ödenen',key:'CEK_ILE_ODENENStr',tdClass:'text-nowrap text-right',thClass:'vt-th-text-right',tooltip:'Belge/çek ile ödenen tutar.'},
                    ]
                },
                {
                    name:'Banka 2 Kesintiler',
                    thClass:'bg-light-danger',
                    children:[
                        {name:'Avans [Banka 2]',key:'BANKA_2_AVANSStr',tdClass:'text-nowrap text-right',thClass:'vt-th-text-right',tooltip:'Banka 2 avans kesintisi (personel cari bakiyesinden).'},
                        {name:'Trafik Cezası [Banka 2]',key:'BANKA_2_TRAFIK_CEZASIStr',tdClass:'text-nowrap text-right',thClass:'vt-th-text-right',tooltip:'Banka 2 trafik cezası kesintisi (personel payı).'},
                        {name:'Vukuat Kesintisi [Banka 2]',key:'BANKA_2_VUKUATStr',tdClass:'text-nowrap text-right',thClass:'vt-th-text-right',tooltip:'Banka 2 vukuat kesintisi (dönem içi ödenen olay taksitleri).'},
                    ]
                },
                {
                    name:'',
                    children:[
                        {name:'Toplam Banka 1 [Yemek Yardımı [Kart] Hariç]',key:"TICKET_HARIC_RESMI_TOPLAMStr",tdClass:'text-nowrap  text-right',thClass:'vt-th-text-right',tooltip:'Banka 1 resmi toplam kesinti/ödeme (Yemek Yardımı [Kart] hariç) = Ödeme [Banka 1] + İcra + BES + Avans [Banka 1] + Trafik Cezası [Banka 1] + Belge İle Ödenen + Vukuat Kesintisi [Banka 1].'},
                        {name:"Yemek Yardım [Kart]",component:true,tdClass:'text-right',componentOptions:{name:"g-salary-ticket/GSalaryTicket"},tooltip:'Yemek yardımı (kart) tutarı.'},
                        {name:'Ödeme [Banka 2]',key:"ELDEN_ODENECEKStr",tdClass:'text-nowrap  text-right',thClass:'vt-th-text-right',tooltip:'Ödeme [Banka 2] (elden) = Toplam Hakediş − (Yemek Yardımı [Kart] dahil resmi toplam + Avans [Banka 2] + Trafik Cezası [Banka 2] + Vukuat [Banka 2]). Maaş Destek Fiili tutarları toplam hakedişe dahil olduğundan buraya da yansır.'},
                    ]
                }
            ],
            buttons:[
                { text:"Düzenle",key:"edit",icon:"Edit2Icon",variant:"secondary",action:this.edit },
            ],
            updating:false,
            data:{
                Id: null,
                MESAI_UCRETI: null,
                YEMEK_UCRETI: null,
                YOL_UCRETI: null,
                PRIM: null,
                DESTEK_PRIMI: null,
                HAMMALIYE_BEDELI: null,
                YATMA: null,
                MAZOT_PRIMI: null,
                SIFIRLAMA: null,
                BAYRAM_MESAISI: null,
                DIGER: null,
                DIGERACIKLAMA: null,
                TICKET: null,
                TICKETExceedAmount: null,
                TRAFIK_CEZA: null 
            },
            uploadObject:{
                File:null,
                Month:null,
                Year:null
            },
            uploading:false
        }
    },
    methods:{
        clearForm(){
            this.data.Id = null
            this.data.MESAI_UCRETI = null
            this.data.YEMEK_UCRETI = null
            this.data.YOL_UCRETI = null
            this.data.PRIM = null
            this.data.DESTEK_PRIMI = null
            this.data.HAMMALIYE_BEDELI = null
            this.data.YATMA = null
            this.data.MAZOT_PRIMI = null
            this.data.SIFIRLAMA = null
            this.data.BAYRAM_MESAISI = null
            this.data.DIGER = null
            this.data.DIGERACIKLAMA = null
            this.data.TICKET = null
            this.data.TRAFIK_CEZA = null
        },
        getData(){
            this.$refs.table.setLoading(true)
            EmployeeOperationsApi.GSalary.Table({
                ...this.filter,
                PaginateRequest:{
                    QueryParam: this.searchValue
                }
            }).then(res => {
                if(res.data.Success){
                    this.datas = res.data.Data.Data?.map((d,i) => ({Order:i+1,...d,Errors:(d.Errors || []).join(', ')}))
                    this.excelPath = res.data.Data.ExcelPath
                }else{
                    this.$result(res)
                }
                this.$refs.table.setLoading(false)
            }).catch(err => {
                this.$result(null,err)
                this.$refs.table.setLoading(true)
            })
        },
        downloadExcel(){
            if(this.excelPath){
                Additional.DownloadTab(this.excelPath)
            }
        },
        uploadExcel(){
            this.uploadObject.File = null
            this.uploadObject.Month = this.donem.month
            this.uploadObject.Year = this.donem.year
            this.$showModal('upload')
        },
        async upload(){
            this.uploading = true
            let formData = await Additional.ToFormData(this.uploadObject,['File'])
            EmployeeOperationsApi.GSalary.UploadGTable(formData).then(res => {
                if(res.data.Success){
                    this.getData()
                    this.$hideModal('upload')
                }
                this.$result(res)
                this.uploading = false
            }).catch(err => {
                this.uploading = false
                this.$result(null,err)
            })
        },
        edit(item){
            this.clearForm()
            this.data.Id = item.Id
            this.data.MESAI_UCRETI = item.MESAI_UCRETI
            this.data.YEMEK_UCRETI = item.YEMEK_UCRETI
            this.data.YOL_UCRETI = item.YOL_UCRETI
            this.data.PRIM = item.PRIM
            this.data.DESTEK_PRIMI = item.DESTEK_PRIMI
            this.data.HAMMALIYE_BEDELI = item.HAMMALIYE_BEDELI
            this.data.YATMA = item.YATMA
            this.data.MAZOT_PRIMI = item.MAZOT_PRIMI
            this.data.SIFIRLAMA = item.SIFIRLAMA
            this.data.BAYRAM_MESAISI = item.BAYRAM_MESAISI
            this.data.DIGER = item.DIGER
            this.data.DIGERACIKLAMA = item.DIGERACIKLAMA
            this.data.TICKET = item.TICKET
            this.data.TRAFIK_CEZA = item.TRAFIK_CEZA
            this.$showModal('edit')
        },
        update(bool = false){
            this.updating = true
            const data = structuredClone(this.data)
            data.MESAI_UCRETI = data.MESAI_UCRETI || 0
            data.YEMEK_UCRETI = data.YEMEK_UCRETI || 0
            data.YOL_UCRETI = data.YOL_UCRETI || 0
            data.PRIM = data.PRIM || 0
            data.DESTEK_PRIMI = data.DESTEK_PRIMI || 0
            data.HAMMALIYE_BEDELI = data.HAMMALIYE_BEDELI || 0
            data.YATMA = data.YATMA || 0
            data.MAZOT_PRIMI = data.MAZOT_PRIMI || 0
            data.SIFIRLAMA = data.SIFIRLAMA || 0
            data.BAYRAM_MESAISI = data.BAYRAM_MESAISI || 0
            data.DIGER = data.DIGER || 0
            data.DIGERACIKLAMA = data.DIGERACIKLAMA || null
            data.TICKET = data.TICKET || 0
            data.TRAFIK_CEZA = data.TRAFIK_CEZA || 0
            EmployeeOperationsApi.GSalary.Update({...data,Override:bool}).then(res => {
                if(res.data.Success){
                    const current = res.data.Data
                    if(current){
                        this.datas = this.datas.map(d => d.Id == current.Id ? ({...current,Order:d.Order}) : d)
                    }
                    this.$result(res)
                    this.$hideModal('edit')
                }else if(res.data.Message == 'OVERRIDE_REQUIRED') {
                    this.$confirm('Düzenlemek istediğinize emin misiniz?','Düzenlemek üzere olduğunuz kayıt onaylanmıştır. Devam etmek istediğinizden emin misiniz?').then(c => {
                        if(c){ this.update(true) }
                    })
                }else{
                    this.$result(res)
                }
                this.updating = false
            }).catch(err => {
                this.updating = false
                this.$result(null,err)
            })
        }
    }
}
</script>